function SearchParentsFor(start, cls, top) {
  var result;

  var parent = start.parentNode;
  if (parent && parent.getAttribute) {
    var pcls = parent.getAttribute("class");
    if (pcls) {
      var pclsArray = pcls.split(" ");
      for (var i = 0; i < pclsArray.length; i++) {
        if (pclsArray[i] == cls) {
          result = parent;
          break;
        }
      }
    }

    if (!result && (!top || parent != top)) {
      result = SearchParentsFor(parent, cls, top);
    }
  }

  return result;
}

window.addEventListener("DOMContentLoaded", function () {
  // Catalogue CTA - OOS
  var postButton = document.querySelector('.action_button[data-method="post"]');
  var postContainer = document.querySelector(
    ".post-container.catalogue_form-container",
  );
  var checkboxes = document.querySelectorAll(
    '.catalogues-container-item input[type="checkbox"]',
  );

  function updatePostButtonVisibility(e) {
    var atLeastOneSelected = false;
    var inStockExists = false;
    var checkbox = e.currentTarget;

    var catalogueItem =
      checkbox && checkbox.closest
        ? checkbox.closest(".catalogues-container-item")
        : null;
    var showOOSText = catalogueItem
      ? catalogueItem.querySelector(".subheader.catalogue-oos")
      : null;
    if (checkbox && checkbox.checked) {
      atLeastOneSelected = true;
      var bookOuter = catalogueItem
        ? catalogueItem.querySelector(".book_image_outer")
        : null;
      var isOutOfStock =
        bookOuter && bookOuter.dataset
          ? bookOuter.dataset.outOfStock === "true"
          : false;
      if (!isOutOfStock) {
        inStockExists = true;
        if (showOOSText && showOOSText.classList)
          showOOSText.classList.add("hidden");
      } else {
        if (showOOSText && showOOSText.classList)
          showOOSText.classList.remove("hidden");
      }
    } else {
      if (showOOSText && showOOSText.classList)
        showOOSText.classList.add("hidden");
    }

    if (!atLeastOneSelected || inStockExists) {
      if (postButton && postButton.classList)
        postButton.classList.remove("hidden");
    } else {
      if (postButton && postButton.classList)
        postButton.classList.add("hidden");
      if (
        postContainer &&
        postContainer.classList &&
        postContainer.classList.contains("hidden") == false
      ) {
        postContainer.classList.add("hidden");
      }
    }
  }

  checkboxes.forEach((cb) =>
    cb.addEventListener("change", updatePostButtonVisibility),
  );
});

function verifyCatalogueChoice() {
  var catalogueIsSelected = false;
  var catalogues = document.querySelectorAll(".book_image_outer");

  for (var i = 0; i < catalogues.length; i++) {
    var catalogue = catalogues[i];

    if (catalogue.classList.contains("active")) {
      catalogueIsSelected = true;
      break;
    }
  }

  return catalogueIsSelected;
}

function showUserInputForm(element) {
  var catalogueSendMethod = element.dataset.method;
  var contactFormContainers = document.querySelectorAll(
    ".catalogue_form-container",
  );
  var error = document.getElementById("catalogue-select-error");

  if (verifyCatalogueChoice()) {
    for (var i = 0; i < contactFormContainers.length; i++) {
      var contactFormContainer = contactFormContainers[i];
      var contactForm = contactFormContainer.querySelector(".catalouge-form");
      var formSendMethod;
      if (contactForm) {
        if (contactForm.dataset.type) {
          formSendMethod = contactForm.dataset.type;
        } else if (contactForm.dataset.method) {
          formSendMethod = contactForm.dataset.method;
        }
      }
      contactFormContainer.classList.add("hidden");

      if (formSendMethod == catalogueSendMethod) {
        contactFormContainer.classList.remove("hidden");
        if (error && error.style) error.style.visibility = "hidden";
      }
    }
  } else {
    if (error && error.style) error.style.visibility = "visible";
  }
}

function HandleCTASuccess(catalogue) {
  var qp = "";
  if (catalogue && catalogue.Catalogue_Type) {
    var responseType = catalogue.Response_Type || "";
    var catalogueTypes = String(catalogue.Catalogue_Type).split(",");
    var multipleTypes = [];
    for (var i = 0; i < catalogueTypes.length; i++) {
      multipleTypes.push(catalogueTypes[i].replace(/\s+/g, "-"));
    }
    qp = multipleTypes.join("-");
    if (responseType) qp += "-" + responseType;
  } else {
    qp = "consultation";
  }

  qp = qp.toLowerCase();

  if (window.lintrk) window.lintrk("track", { conversion_id: 24030218 });
  if (window.fbq) fbq("track", "Lead", {});

  setTimeout(function () {
    var redirection_URL =
      window.location.origin + "/pages/thank-you?type=brochure-request";
    if (catalogue && catalogue.Response_Type == "POST" && catalogue.Postcode) {
      redirection_URL +=
        "&" + "Postcode=" + String(catalogue.Postcode).replace(/\s+/g, "-");
    }
    window.location.href = redirection_URL;
  }, 1000);
}

function onSearchBlur() {
  var mannualAddress = document.querySelector("#manual-address");
  if (mannualAddress) mannualAddress.checked = false;
}

window.addEventListener("DOMContentLoaded", function () {
  // EMAIL FORM
  // ---------------------------------
  var catalogueForm = document.querySelector("#catalogue_form");
  if (catalogueForm) {
    catalogueForm.addEventListener("submit", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // This is to prevent the .submit firing twice

      if (typeof hj === "function") hj("event", "retail_catalogue_request");

      var selectedCatalogues = document.querySelectorAll(
        ".single_book .active",
      );

      function HandleCatalogues(catalogueName, catalogueType) {
        var selectErrorEl = document.querySelector("#catalogue-select-error");
        if (selectErrorEl && selectErrorEl.classList)
          selectErrorEl.classList.add("hidden");
        if (selectErrorEl && selectErrorEl.style)
          selectErrorEl.style.visibility = "hidden";
        var form = e.currentTarget;

        var first_name_el = form.querySelector("#catalogue_First_Name");
        var last_name_el = form.querySelector("#catalogue_Last_Name");
        var email_el = form.querySelector("#catalogue_email");
        var phone_el = form.querySelector("#catalogue_Phone");
        var postcode_el = form.querySelector('[name="catalogue_Postcode"]');
        var accepts_el = form.querySelector("input[ name='data-capture' ]");
        var where_el = form.querySelector(
          '[name="catalogue_Where_did_you_hear_about_us"]',
        );

        var first_name = first_name_el ? first_name_el.value : "";
        var last_name = last_name_el ? last_name_el.value : "";
        var email = email_el ? email_el.value : "";
        var phone_number = phone_el ? phone_el.value : "";
        var Postcode = postcode_el ? postcode_el.value : "";
        var accepts_marketing = accepts_el ? accepts_el.checked : false;
        var Where_did_you_hear_about_us = where_el ? where_el.value : "";
        var have_you_heard_of_bridgman_before = "No";

        var selectedRadio = form.querySelector(
          'input[name="have_you_heard_of_bridgman_before"]:checked',
        );
        if (selectedRadio !== null) {
          have_you_heard_of_bridgman_before = selectedRadio.value;
        }

        if (Where_did_you_hear_about_us == "Other") {
          Where_did_you_hear_about_us = form.querySelector(
            '[name="catalogue_Where_did_you_hear_about_us_other"]',
          ).value;
        }

        var catalogue = {
          Response_Type: "Email",
          Catalogue_Type: catalogueType.toString(),
          Catalogue_Name: catalogueName,
          Postcode: Postcode,
          $source: Where_did_you_hear_about_us,
          $email: email,
          $first_name: first_name,
          $last_name: last_name,
          $phone_number: phone_number,
          $have_you_heard_of_bridgman_before: have_you_heard_of_bridgman_before,
        };

        var properties = {
          $email: email,
          Catalogue_Type: catalogue.Catalogue_Type,
          Catalogue_Name: catalogue.Catalogue_Name,
          $source: catalogue.$source,
          Response_Type: "Email",
          $accepts_marketing: accepts_marketing,
        };

        let mergedProperties = properties;
        let mergedCatalogue = catalogue;
        const utmProperties = utmParams();
        if (utmProperties) {
          mergedProperties = { ...properties, ...utmProperties };
          mergedCatalogue = { ...catalogue, ...utmProperties };
        }

        var trackProperties = {
          event: "Request Catalogue",
          trackData: mergedCatalogue,
        };
        KlaviyoTrackV2(mergedProperties, trackProperties, function () {
          jQuery
            .post(
              "https://hooks.zapier.com/hooks/catch/9220888/o0xxmfx/silent/",
              mergedCatalogue,
            )
            .then(function () {
              HandleCTASuccess(catalogue);
            });
        });
      }

      if (selectedCatalogues && selectedCatalogues.length > 0) {
        var catalogueName = [];
        var catalogueType = [];
        if (selectedCatalogues.length > 1) {
          for (var i = 0; i < selectedCatalogues.length; i++) {
            catalogueName.push(
              selectedCatalogues[i].getAttribute("data-catalogue-name"),
            );
            if (
              catalogueType.includes(
                selectedCatalogues[i].getAttribute("data-catalogue-type"),
              ) == false
            ) {
              catalogueType.push(
                selectedCatalogues[i].getAttribute("data-catalogue-type"),
              );
            }
          }
          catalogueName = "MULTIPLE - " + catalogueName.toString();
        } else {
          catalogueName = selectedCatalogues[0].getAttribute(
            "data-catalogue-name",
          );
          catalogueType.push(
            selectedCatalogues[0].getAttribute("data-catalogue-type"),
          );
        }

        if (selectedCatalogues.length > 0) {
          HandleCatalogues(catalogueName, catalogueType);
        }
      } else {
        var selectErrorEl = document.querySelector("#catalogue-select-error");
        if (selectErrorEl && selectErrorEl.classList)
          selectErrorEl.classList.remove("hidden");
        if (selectErrorEl && selectErrorEl.style)
          selectErrorEl.style.visibility = "visible";
      }
    });
  }

  // POST FORM
  // ---------------------------------
  var catalogueFormPost = document.querySelector("#catalogue_form_post");
  if (catalogueFormPost) {
    catalogueFormPost.addEventListener("submit", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // This is to prevent the .submit firing twice

      if (typeof hj === "function") hj("event", "retail_catalogue_request");

      var selectedCatalogues = document.querySelectorAll(
        ".single_book .active",
      );

      function HandleCatalogues(catalogueName, catalogueType) {
        var selectErrorEl = document.querySelector("#catalogue-select-error");
        if (selectErrorEl && selectErrorEl.classList)
          selectErrorEl.classList.add("hidden");
        if (selectErrorEl && selectErrorEl.style)
          selectErrorEl.style.visibility = "hidden";

        var form = e.currentTarget;
        var first_name_el = form.querySelector("#catalogue_First_Name");
        var last_name_el = form.querySelector("#catalogue_Last_Name");
        var email_el = form.querySelector("#catalogue_email");
        var phone_el = form.querySelector('[name="catalogue_Phone"]');
        var postcode_el = form.querySelector('[name="catalogue_Postcode"]');
        var addr1_el = form.querySelector('[name="catalogue_Address_Line_1"]');
        var addr2_el = form.querySelector('[name="catalogue_Address_Line_2"]');
        var city_el = form.querySelector('[name="catalogue_City"]');
        var country_el = form.querySelector('[name="catalogue_Country"]');
        var accepts_el = form.querySelector("input[ name='data-capture' ]");

        var first_name = first_name_el ? first_name_el.value : "";
        var last_name = last_name_el ? last_name_el.value : "";
        var email = email_el ? email_el.value : "";
        var phone_number = phone_el ? phone_el.value : "";
        var Postcode = postcode_el ? postcode_el.value : "";
        var Address_Line_1 = addr1_el ? addr1_el.value : "";
        var Address_Line_2 = addr2_el ? addr2_el.value : "";
        var City = city_el ? city_el.value : "";
        var Country = country_el ? country_el.value : "";
        var accepts_marketing = accepts_el ? accepts_el.checked : false;
        var have_you_heard_of_bridgman_before = "No";
        var selectedRadio = form.querySelector(
          'input[name="have_you_heard_of_bridgman_before"]:checked',
        );

        if (selectedRadio !== null) {
          have_you_heard_of_bridgman_before = selectedRadio.value;
        }

        var Where_did_you_hear_about_us = form.querySelector(
          '[name="catalogue_Where_did_you_hear_about_us"]',
        ).value;
        if (Where_did_you_hear_about_us == "Other") {
          Where_did_you_hear_about_us = form.querySelector(
            '[name="catalogue_Where_did_you_hear_about_us_other"]',
          ).value;
        }

        var catalogue = {
          Response_Type: "POST",
          Catalogue_Type: catalogueType.toString(),
          Catalogue_Name: catalogueName,
          Postcode: Postcode,
          $email: email,
          $first_name: first_name,
          $last_name: last_name,
          $address1: Address_Line_1,
          $address2: Address_Line_2,
          $city: City,
          $country: Country,
          $phone_number: phone_number,
          $source: Where_did_you_hear_about_us,
          $have_you_heard_of_bridgman_before: have_you_heard_of_bridgman_before,
        };

        var properties = {
          $email: email,
          Catalogue_Type: catalogue.Catalogue_Type,
          Catalogue_Name: catalogue.Catalogue_Name,
          $source: catalogue.$source,
          Response_Type: "POST",
          $accepts_marketing: accepts_marketing,
        };

        let mergedProperties = properties;
        let mergedCatalogue = catalogue;
        const utmProperties = utmParams();
        if (utmProperties) {
          mergedProperties = { ...properties, ...utmProperties };
          mergedCatalogue = { ...catalogue, ...utmProperties };
        }

        var trackProperties = {
          event: "Request Catalogue",
          trackData: mergedCatalogue,
        };

        KlaviyoTrackV2(mergedProperties, trackProperties, function () {
          jQuery
            .post(
              "https://hooks.zapier.com/hooks/catch/9220888/o0xxmfx/silent/",
              mergedCatalogue,
            )
            .then(function () {
              HandleCTASuccess(catalogue);
            });
        });
      }

      if (selectedCatalogues && selectedCatalogues.length > 0) {
        var catalogueName = [];
        var catalogueType = [];
        if (selectedCatalogues.length > 1) {
          for (var i = 0; i < selectedCatalogues.length; i++) {
            catalogueName.push(
              selectedCatalogues[i].getAttribute("data-catalogue-name"),
            );
            if (
              catalogueType.includes(
                selectedCatalogues[i].getAttribute("data-catalogue-type"),
              ) == false
            ) {
              catalogueType.push(
                selectedCatalogues[i].getAttribute("data-catalogue-type"),
              );
            }
          }
          catalogueName = "MULTIPLE - " + catalogueName.toString();
        } else {
          catalogueName = selectedCatalogues[0].getAttribute(
            "data-catalogue-name",
          );
          catalogueType.push(
            selectedCatalogues[0].getAttribute("data-catalogue-type"),
          );
        }

        if (selectedCatalogues.length > 0) {
          HandleCatalogues(catalogueName, catalogueType);
        }
      } else {
        var selectErrorEl = document.querySelector("#catalogue-select-error");
        if (selectErrorEl && selectErrorEl.classList)
          selectErrorEl.classList.remove("hidden");
        if (selectErrorEl && selectErrorEl.style)
          selectErrorEl.style.visibility = "visible";
      }
    });
  }
});
